<template>
	<div>
		<!-- 登录信息 -->
		<global-tips></global-tips>
		<el-card>
			<!-- 搜索框 -->
			 <el-form v-show="showSearch" ref="queryForm" :model="queryForm" inline size="small">
				<el-form-item label="名称" label-width="50px" prop="keyword">
				  <el-input v-model="queryForm.keyword" placeholder="请输入名称" type="text" clearable style="width: 230px" />
				</el-form-item>
				<el-form-item>
				  <el-button type="primary" icon="el-icon-search" size="mini" @click="query">查询</el-button>
				  <el-button icon="el-icon-refresh" size="mini" @click="resetQuery('queryForm')">重置</el-button>
				</el-form-item>
			</el-form>
			<!--自定义刷新组件-->
			<el-row :gutter="10" class="mb-1">
				<el-button type="primary" icon="el-icon-plus" size="mini" @click="handleAdd">新增</el-button>
				<right-toolbar :show-search.sync="showSearch" @queryTable="query" />
			</el-row>
			<!--表格-->
			 <el-table
				v-loading="loading"
				size="small"
				:data="list"
				element-loading-text="Loading"
				highlight-current-row
				style="width: 100%"
			 >
				<el-table-column label="序号" width="80" align="center">
				  <template slot-scope="scope">
					{{ (queryForm.page - 1) * queryForm.limit + scope.$index + 1 }}
				  </template>
				</el-table-column>
				<el-table-column label="设备号" min-width="110" align="center">
				  <template slot-scope="scope">
					<span>{{ scope.row.device_id }}</span>
				  </template>
				</el-table-column>
				<el-table-column label="设备类型" min-width="110" align="center">
				  <template slot-scope="scope">
					<span>{{ scope.row.device_type == 1 ? 'PEMF细胞能量舱' : 'PEMF细胞能量仪' }}</span>
				  </template>
				</el-table-column>
				<el-table-column label="二维码" min-width="110" align="center">
				  <template slot-scope="scope">
					<img :src="scope.row.url" style="width: 50px;height: 50px;" @click="viewImage(scope.row,'url')" v-if="scope.row.url">
					<img src="@/assets/images/empty.png" style="width: 50px;height: 50px;" v-else>
				  </template>
				</el-table-column>
				<el-table-column align="center" prop="utime" label="时间" min-width="170">
				  <template slot-scope="scope">
					<i class="el-icon-time" />
					<span>{{ scope.row.ctime }}</span>
				  </template>
				</el-table-column>
				<el-table-column label="操作" min-width="100" align="center" fixed="right">
				  <template slot-scope="scope">
	<!-- 				<el-tooltip class="item" effect="dark" content="编辑" placement="top">
					  <el-button type="success" icon="el-icon-edit" size="mini" circle @click="handleEdit(scope.row)"></el-button>		
		            </el-tooltip> -->
					<el-tooltip class="item" effect="dark" content="删除" placement="top">
					  <el-button type="danger" icon="el-icon-delete" size="mini" circle @click="handleDelete(scope.row.id)"></el-button>		
					</el-tooltip>
				  </template>
				</el-table-column>
			 </el-table>
			 <pagination
				:total="total"
				auto-scroll
				:page.sync="queryForm.page"
				:limit.sync="queryForm.limit"
				@pagination="query"
			 />
		</el-card>
		<!-- 编辑-->
		<el-dialog :visible.sync="open" width="600px" :close-on-click-modal="false" append-to-body :title="title">
		  <el-form ref="form" :model="form" :rules="rules" label-width="100px" size="small">
		    <el-form-item label="设备号" prop="device_id">
		      <el-input v-model="form.device_id" placeholder="请输入设备号" type="text" clearable />
		    </el-form-item>
			<el-form-item label="设备类型" prop="device_type">
		      <el-select v-model="form.device_type" placeholder="请选择设备类型" size="medium" class="w-100">
				<el-option v-for="(item,index) in types" :key="index"
					:label="item.name"
					:value="item.id">
				</el-option>
			  </el-select>
		    </el-form-item>
		  </el-form>
		  <div slot="footer" class="dialog-footer">
		    <el-button size="mini" @click="cancel">取 消</el-button>
		    <el-button type="primary" size="mini" @click="handleSubmit">确 定</el-button>
		  </div>
		</el-dialog>
	</div>
</template>

<script>
	import GlobalTips from "@/components/GlobalTips";
	import common from "@/common/mixins/common.js"
	export default {
		inject:['app'],
		mixins:[common],
		components: {
			GlobalTips,
		},
		data() {
			return {
				preUrl: 'dc_ewm',
				queryForm: {
					page: 1,
					limit: 10,
					keyword: '',
				},
				form:{
					device_id: '',
					device_type:null,
				},
				rules:{
					device_id: [
					  { required: true, message: '请输入设备号', trigger: 'blur' }
					],
					device_type: [
					  { required: true, message: '请选择设备类型', trigger: 'blur' }
					],
				},
				types:[
					{id:1,name:'PEMF细胞能量舱'},
					{id:2,name:'PEMF细胞能量仪'},
				],
			}
		},
		mounted() {
			
		},
		methods:{
			reset() {
			  this.form = {
				  device_id: '',
				  device_type: '',
			  }
			  this.resetForm('form')
			},
		}
	}
</script>

<style>
</style>